import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import React from "react";
import type { ExpectationStep } from "../../content/roleFaqsContent";
import { Reveal, StaggerGroup } from "../../theme/animation";

interface ExpectationsSectionProps {
  /** Heading for the section (e.g. "Athlete Expectations"). Falls back to sectionTitle if omitted. */
  heading?: string;
  sectionTitle: string;
  steps: ExpectationStep[];
  id?: string;
}

const ExpectationsSection: React.FC<ExpectationsSectionProps> = ({
  heading,
  sectionTitle,
  steps,
  id = "expectations",
}) => {
  const h2Text = heading ?? sectionTitle;

  return (
    <Box id={id} component="section" sx={{ mb: 6 }}>
      <Reveal variant="fadeUp">
        <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: "bold" }}>
          {h2Text}
        </Typography>
      </Reveal>
      <StaggerGroup stagger={0.08}>
        {steps.map((step, index) => (
          <Reveal key={step.stepNumber} variant="fadeUp" staggerIndex={index}>
            <Accordion elevation={2} sx={{ mb: 2 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`expectations-panel-${step.stepNumber}-content`}
            id={`expectations-panel-${step.stepNumber}-header`}
            sx={{
              "& .MuiAccordionSummary-content": { margin: "16px 0" },
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Step {step.stepNumber}: {step.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {step.variants.length === 1 ? (
              <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                {step.variants[0]}
              </Typography>
            ) : (
              <Box>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  {step.variants[0]}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    fontStyle: "italic",
                    my: 1,
                    color: "text.secondary",
                  }}
                >
                  Or
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  {step.variants[1]}
                </Typography>
              </Box>
            )}
          </AccordionDetails>
            </Accordion>
          </Reveal>
        ))}
      </StaggerGroup>
    </Box>
  );
};

export default ExpectationsSection;
